"use strict"
exports.__esModule = true;
exports.SplotchIconConfig = {
  name: 'SplotchIcon',
  height: 512,
  width: 512,
  svgPath: 'M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z',
  yOffset: 0,
  xOffset: 0,
};
exports.SplotchIcon = require('../createIcon').createIcon(exports.SplotchIconConfig);
exports["default"] = exports.SplotchIcon;